<style scoped>

  #update-button {
    margin-bottom: 15px;
  }

</style>

<template>
  
  <div>

    <div class="ui large breadcrumb">      
      <a class="clickable" @click="$historyBack()">
        <i class="reply icon m-r-5"></i>
        {{ $route.query.historyBack && $route.query.historyBack == "true" ? "Voltar" : "Fichas Cadastrais" }}
      </a>
      <i class="right chevron icon divider"></i>
      <div class="section">
        <strong>Visualizar Ficha Cadastral</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div v-if="loading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-else class="animated fadeIn">  

      <div v-show="$isSimavet()" id="update-button" class="ui floating dropdown button">
        <i class="edit grey icon"></i> Alterar
        <div class="menu">
          <div class="item" @click="$refs.formModal.update(registration)">
            <i class="file alternate outline icon"></i> Ficha Cadastral
          </div>
          <div class="item" @click="$refs.animalFormModal.update({ animalId: registration.animalId })">
            <i class="paw violet icon"></i> Animal
          </div>
          <div class="item" @click="$refs.ownerModal.update(registration.owner)">
            <i class="user circle outline teal icon"></i> Tutor
          </div>
        </div>
      </div>

      <horizontal-tabs class="m-b-15" ref="horizontalTabs" :tabs="tabs" @onSelectTab="onSelectTab" />

      <overview-tab v-if="activeTab == 'overview'" :registration="registration" />
      <attachments-tab v-if="activeTab == 'attachments'" :registration="registration" />
      <certs-tab v-if="activeTab == 'certs'" :registration="registration" />

    </div>  

    <form-modal ref="formModal" @onSave="onSave" @onRemove="onRemove" />

    <animal-form-modal ref="animalFormModal" @onSave="loadRegistration" @onRemove="loadRegistration" 
      @onShowPictures="onShowPictures" @onShowOwner="onShowOwner" />

    <pictures-modal ref="picturesModal" />

    <owner-modal ref="ownerModal" @onSave="loadRegistration" @onShowAnimals="onShowAnimals" />

  </div>

</template>  

<script>

  import AnimalRegistrationService from "@/services/animal-registration-service"  
  import HorizontalTabs from "@/components/horizontal-tabs"
  import OverviewTab from "./overview"
  import AttachmentsTab from "./private-attachments"
  import CertsTab from "./certs"
  import FormModal from "../form-modal"
  import AnimalFormModal from "@/pages/entries/animals/form-modal"
  import PicturesModal from "@/pages/entries/animals/pictures-modal"
  import OwnerModal from "@/pages/entries/owners/form-modal"

  export default {
    
    name: "ShowAnimalRegistrationPage",

    data() {
      return {
        service: new AnimalRegistrationService(),
        registration: {},
        loading: true,
        activeTab: "overview",
        tabs: [],  
      }
    },

    components: {
      HorizontalTabs,
      OverviewTab,
      AttachmentsTab,
      CertsTab,
      FormModal,
      AnimalFormModal,
      PicturesModal,
      OwnerModal,
    },

    mounted() {      

      this.tabs = [
        { id: "overview", label: "Visão Geral" },
      ]

      if (this.$isSimavet())
        this.tabs.push({ id: "attachments", label: "Anexos" })        

      this.tabs.push({ id: "certs", label: "Laudos" })  

      this.loadRegistration()
    },

    methods: {

      async loadRegistration() {

        this.loading = true

        try {

          this.registration = await this.service.findById(this.$route.params.id)

          this.checkUserProfile()                   

        } catch (error) {

          this.$errorHandler(error)

        } finally {

          this.loading = false

          if (this.$isSimavet()) {
            setTimeout(() => $("#update-button").dropdown(), 800)
          }            
        }
      },

      onSave() {
        this.$reloadDataTables()
        this.loadRegistration()
      },

      onRemove() {
        this.$reloadDataTables()
        this.$historyBack()
      },

      onSelectTab(id) {
        this.activeTab = id
      },

      checkUserProfile() {

        if (this.$isSimavet())
          return true

        let allowed = true        
        let customerIds = []

        this.$store.state.auth.user.customers.forEach((customer) => customerIds.push(customer.id))

        allowed = (customerIds.indexOf(this.registration.customerId) > -1)

        if (!allowed)
          this.$router.push("/not-found")    
      },

      onShowPictures(animalId) {
        this.$refs.picturesModal.show(animalId)
      },

      onShowOwner(owner) {
        this.$refs.ownerModal.update(owner)
      },

      onShowAnimals(owner) {
        this.$router.push(`/entries/owners/${owner.id}/animals`)
      },
    },
  }

</script>  